var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21px",
  height: "21px",
  viewBox: "0 0 21 21",
  xmlns: "http://www.w3.org/2000/svg",
  className: "react-svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("rect", {
  transform: "translate(9.961900, 10.500000) scale(-1, 1) translate(-9.961900, -10.500000) ",
  x: 4.96189958,
  y: 9,
  width: 10,
  height: 3,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  transform: "translate(13.085786, 11.914214) rotate(-45.000000) translate(-13.085786, -11.914214) ",
  x: 9.58578644,
  y: 10.4142136,
  width: 7,
  height: 3,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  transform: "translate(13.085786, 9.085786) rotate(-315.000000) translate(-13.085786, -9.085786) ",
  x: 9.58578644,
  y: 7.58578644,
  width: 7,
  height: 3,
  rx: 1
})))));
export default SvgArrowRight;